export const config = {
  cognito: {
    region: "us-east-1",
    userPoolId: "us-east-1_vAFvpDQeg",
    clientId: "a5v9pj56q7e0qv1vv29958pca",
    domain: "metabetta-blog.auth.us-east-1.amazoncognito.com",
    redirectUri: window.location.origin + "/login/callback",
    logoutUri: window.location.origin,
  },
  api: {
    baseUrl: "https://api.metabetta.com",
  },
};
